import React from 'react';
import styled from 'styled-components/macro';

import AnimatedLoadingWrapper from 'components/base/AnimatedLoadingWrapper';
import TabsSkeletonLoader from './TabsSkeletonLoader';
import Tabs from './Tabs';
import { ChartTypes } from 'types/shared';
import { IToggleOption } from 'components/data-containers/PositionsTable/TableControls/DSPToggle';

const Layout = styled('div')`
  margin: 0 auto;
  background-color: ${({ theme }): string => theme.White};

  @media screen and (min-width: 60em) {
    max-width: calc(100% - (2em * 2));
  }

  @media screen and (min-width: 80em) {
    max-width: calc(100% - (8em * 2));
  }
`;

interface IChartsTabsProps {
  isLargeScreen: boolean;
  chartPage: ChartTypes;
  title: string;
  isLoadingCustomers: boolean;
  selectedCustomer: IToggleOption | null;
  uniqueCustomers: IToggleOption[];
  setSelectedCustomer: (customer: IToggleOption) => void;
  variation: string;
}

const ChartsTabs: React.FC<IChartsTabsProps> = (props) => {
  const {
    chartPage,
    isLargeScreen,
    title,
    isLoadingCustomers,
    selectedCustomer,
    uniqueCustomers,
    setSelectedCustomer,
    variation,
  } = props;

  return (
    <Layout data-pw="chart-tabs-section">
      <AnimatedLoadingWrapper loading={isLoadingCustomers}>
        {!isLoadingCustomers && selectedCustomer ? (
          <Tabs
            isLargeScreen={isLargeScreen}
            chartPage={chartPage}
            title={title}
            isLoadingCustomers={isLoadingCustomers}
            uniqueCustomers={uniqueCustomers}
            selectedCustomer={selectedCustomer}
            variation={variation}
            setSelectedCustomer={setSelectedCustomer}
          />
        ) : (
          <TabsSkeletonLoader
            isLargeScreen={isLargeScreen}
            chartPage={chartPage}
            title={title}
            isLoadingCustomers={isLoadingCustomers}
          />
        )}
      </AnimatedLoadingWrapper>
    </Layout>
  );
};

export default ChartsTabs;
